import React, { Props } from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock, FormControlProps, Glyphicon } from 'react-bootstrap';
import { observer } from 'mobx-react';

interface IFieldGroupProps {
  id : string,
  label : string,
  help? : string,
  isValid? : boolean,
  message? : string,
  required? : boolean
};

type FieldGroupProps = IFieldGroupProps & FormControlProps;

const isRequired : Function = (required : boolean) => {
  if(required)
    return <Glyphicon glyph='asterisk' className='required'></Glyphicon>;
}

export const FieldGroup = observer(({ id, label, help, isValid, message, required, ...props } : FieldGroupProps) => {
  return (
    <FormGroup controlId={id} >
      <ControlLabel>
        {label}&nbsp;
        {isRequired(required)}
      </ControlLabel>
      <FormControl {...props} componentClass={{...props}.type === 'select' ? 'select' : 'input'}>
        {props.children}
      </FormControl>
      {!isValid && <HelpBlock className='text-danger'>{message}</HelpBlock>}
    </FormGroup>
  );
});